module.exports = __webpack_public_path__ + "static/media/portfolio_dissertation.46aa6cfb.png";